import { gql } from "@apollo/client";

export const addCompanyPolicy = gql`
  mutation addCompanyPolicy($record: CreateOneCompanyPolicyInput!) {
    companyPolicy_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;


